export default "__VITE_ASSET__54a143d8__"